





import { Component, Prop, Vue } from 'vue-property-decorator';
import { Marked, MarkedOptions } from 'marked-ts'
import { MDDocument, MDCloudStatus } from '@/struct/mddocument';

@Component
export default class MarkdownEditPreviewer extends Vue {
  @Prop() document!: MDDocument

  get htmldoc(): string {
    const option = new MarkedOptions()
    option.gfm = true
    option.breaks = true
    return Marked.parse(this.document.text, option)
  }
}
